var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.293031 9.70692C0.10556 9.51939 0.000244141 9.26508 0.000244141 8.99992C0.000244141 8.73475 0.10556 8.48045 0.293031 8.29292L3.58603 4.99992L0.293031 1.70692C0.110873 1.51832 0.0100779 1.26571 0.0123563 1.00352C0.0146347 0.741321 0.119804 0.490509 0.305212 0.305101C0.49062 0.119692 0.741433 0.0145233 1.00363 0.0122448C1.26583 0.00996641 1.51843 0.110761 1.70703 0.292919L5.70703 4.29292C5.8945 4.48045 5.99982 4.73475 5.99982 4.99992C5.99982 5.26508 5.8945 5.51939 5.70703 5.70692L1.70703 9.70692C1.5195 9.89439 1.26519 9.99971 1.00003 9.99971C0.734866 9.99971 0.480558 9.89439 0.293031 9.70692Z",
    fill: "#374151"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/next-icon.7e224172642331c1e361f67bd8802481.svg";
export { ForwardRef as ReactComponent };